import React, { useState, useRef } from 'react';
import { useEffect } from 'react';

const AISoTitle = ({ question }) => {
  const [showAll, setShowAll] = useState(true);
  const titleRef = useRef(null);

  useEffect(() => {
    if (titleRef.current) {
      const { height } = titleRef.current.getBoundingClientRect();
      if (height > 272) {
        setShowAll(false);
      }
    }
  }, [titleRef.current]);

  const handleShowAll = () => {
    setShowAll(true);
  };


  return (
    <div
      ref={titleRef}
      className={[
        `${question.length > 40 ? 'text-24px leading-34px' : 'text-32px leading-45px'}`,
        showAll ? '' : 'max-h-272px overflow-hidden',
        'mt-8px relative font-bold-500',
      ]}
    >
      {question}
      <div
        className={[
          'h-144px w-full absolute bottom-0 right-0',
          'flex justify-center items-center',
          showAll ? 'hidden' : '',
        ]}
        style={{
          background:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.70) 47.09%, #FFF 91.67%)',
        }}
      >
        <button
          className={[
            'w-120px h-32px mt-92px text-14px text-black bg-white rounded-16px border border-black border-opacity-16 text-center',
            'hover:bg-[#f5f5f5]',
          ]}
          style={{
            boxShadow:
              '0px 0px 2px 0px rgba(0, 0, 0, 0.12), 0px 2px 4px 0px rgba(0, 0, 0, 0.12)',
          }}
          onClick={handleShowAll}
        >
          查看全部
        </button>
      </div>
    </div>
  );
};

export default AISoTitle;
